import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

export default class SystemSupport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      isLoading: !props.systemSettings,
      momentFormatString: 'ddd Do MMM YYYY',
      momentFormatStringCSV: 'ddd Do MMM YYYY - HHmmss',
      selectedJobId: null,
      selectedTask: null,
      editAppraisalJson: false,
      appraisalJson: null,
      isLoadingAppraisalInfo: true,
      saveAppraisalJsonChangesEndpoint: '/api/v1/portal/appraisal-info',
      loadBlankAppraisalDataEndpoint: '/api/v1/portal/load-blank-appraisal-info',
      jobImagesDirectoryListing: null,
      jobImagesDirectoryListingUploadCare: null,
      uploadImageTypeValue: '',
      uploadImageTypeLabel: '',
      includeLockedDriversInCurrentVersionReport: false,
      driverAppCurrentVersionReport: '',
      driverAppCurrentVersionReportJson: [],
      isLoadingDriverAppCurrentVersionReport: false,
    };

    this.uploadJobImage = this.uploadJobImage.bind(this);
    this.addBlankAppraisalJSON = this.addBlankAppraisalJSON.bind(this);
  }

  fixAppraisalJson() {
    let jobId = prompt(
      "Please enter JOB ID",
      "?");
    if (jobId != null) {
      this.setState({
        selectedJobId: jobId,
        selectedTask: 'fix_appraisal'
      });
    }
    else {
      alert('Error no JOB ID. please enter JOB ID');
    }
  }

  plateTrace() {
    this.setState({
      selectedTask: 'plate_trace'
    });
  }
  getReport() {
    return {__html: this.state.driverAppCurrentVersionReportJson.report}
  }
  driverAppCurrentVersionReport() {
    this.setState({
      selectedTask: 'driver_app_current_version_report'
    });
  }
  generateDriverAppCurrentVersionReport() {
    this.setState({
      isLoadingDriverAppCurrentVersionReport: true,
      editAppraisalJson: false,
    });

    let url = '/api/v1/portal/portal-admin/system-support/driver-app-current-version-report';

    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driverAppCurrentVersionReportJson) => {
        this.setState({
          driverAppCurrentVersionReportJson: driverAppCurrentVersionReportJson,
          isLoadingDriverAppCurrentVersionReport: false
        })
      });
    });
  }
  getAppraisalInfo() {
    this.setState({
      isLoadingAppraisalInfo: true,
      editAppraisalJson: false,
    });

    if (this.state.selectedJobId == null) {
      return false;
    }

    let url = '/api/v1/portal/appraisal-info/'+this.state.selectedJobId;

    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((appraisalInfoJson) => {
        this.setState({
          appraisalJson: appraisalInfoJson,
          isLoadingAppraisalInfo: false
        })
      });
    });
  }

  tracePlate() {
    if (this.state.selectedJobId == null) {
      return false;
    }
    let url = '/api/v1/portal/portal-admin/system-support/'+this.state.selectedJobId;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((appraisalInfoJson) => {
        this.setState({
          appraisalJson: appraisalInfoJson,
          isLoadingAppraisalInfo: false
        })
      });
    });
  }

  triggerUpload(id) {
    $(".image-input").trigger('click');
  }

  getImagesDirectoryListingInfo() {
    if (this.state.selectedJobId == null) {
      return false;
    }
    this.setState({
      isLoadingImagesDirectoryListing: true,
      isLoadingImagesDirectoryListingUploadCare: true,
      editAppraisalJson: false
    });
    let jobId = this.state.selectedJobId;
    let url = '/api/v1/portal/portal-admin/system-support/job-image-directory-listing/'+jobId;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((jobImagesDirectoryListingInfo) => {
        this.setState({
          jobImagesDirectoryListing: jobImagesDirectoryListingInfo.storage_file_urls,
          isLoadingImagesDirectoryListing: false,
          jobImagesDirectoryListingUploadCare: jobImagesDirectoryListingInfo.uploadcare_image_urls,
          isLoadingImagesDirectoryListingUploadCare: false
        })
      });
    });
  }

  getImagesDirectoryListing() {
    this.setState({
      selectedTask: 'get_job_images_directory_listing',
      getImagesDirectoryListing: true
    });
  }

  editAppraisal() {
    this.getAppraisalInfo();
    this.setState({
      editAppraisalJson: true,
    });
  }

  copyPickupToDropoff() {
    return fetch (
      '/api/v1/portal/portal-admin/system-support/'+
      'copy-pickup-to-dropoff/'+this.state.selectedJobId,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json',
          "Content-Type": 'application/json'
        },
      }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        console.log(response);
        this.setState({
          appraisalJson: response
        });
      });
    });
  }
  mergePickupAndDropoff() {
    return fetch(
      '/api/v1/portal/portal-admin/system-support/' +
        'merge-pickup-and-dropoff/' +
        this.state.selectedJobId,
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          Authorization: 'Bearer ' + window.api_token,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    ).then((responseText) => {
      let response = responseText.json()
      response.then((response) => {
        this.setState({
          appraisalJson: response,
        })
      })
    })
  }
  saveAppraisalJsonChanges() {
    let confirmSaveChanges = confirm(
      'Are you sure you want to overwrite the appraisal JSON for Job id = ' +
      this.state.selectedJobId +
      '?'
    );

    if (confirmSaveChanges === true) {
      return fetch(
        this.state.saveAppraisalJsonChangesEndpoint+'/'+
        this.state.selectedJobId+'/'+
        'support-edit', {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token,
            "Accept": 'application/json',
            "Content-Type": 'application/json'
          },
          body: JSON.stringify(this.state.appraisalJson)
        }).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          console.log(response);
          alert(
            'Appraisal Changes for Job id = '+
            this.state.selectedJobId+
            ' saved successfully!'
          );

          this.setState({
            selectedJobId: null
          });
        });
      });
    }
    else {
      alert('Appraisal JSON changes for Job id = '+
        this.state.selectedJobId+
        ' not saved.'
      );
    }
  }

  uploadJobImage(e) {
    let jobId = this.state.selectedJobId;
    let uploadImageTypeValue = this.state.uploadImageTypeValue;
    let uploadInput = document.getElementById(
      'image-input'
    );

    if (
      uploadInput &&
      uploadInput.files &&
      uploadInput.files[0]
    ) {
      let fileReader = new FileReader();
      fileReader.addEventListener("load", function(e) {
        document.getElementById("b64").value = e.target.result;
        let newJobImageData = {
          api_token: window.api_token,
          image: e.target.result,
          type: uploadImageTypeValue
        };

        $.ajax({
          type: "POST",
          url: '/api/v1/portal/portal-admin/system-support/upload-image-to-job/'+jobId,
          data: newJobImageData,
          dataType: "text/json",
          complete: function(response) {
            if (response.status === 200) {
              alert('image changed');
            }
            else {
              alert('error uploading new image. check data and try again');
            }
          }
        });
      });
      fileReader.readAsDataURL(uploadInput.files[0]);
    }
  }

  addBlankAppraisalJSON(e)
  {
    let confirmSaveChanges = confirm(
      'Are you sure you want to add the blank appraisal JSON for Job id = ' +
      this.state.selectedJobId +
      '?'
    );
    var that = this;
    if (confirmSaveChanges === true) {
      this.setState({
        isLoadingAppraisalInfo: true,
        editAppraisalJson: false,
      });
  
      if (this.state.selectedJobId == null) {
        return false;
      }
      return fetch(
        this.state.loadBlankAppraisalDataEndpoint+'/'+
        this.state.selectedJobId, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token,
            "Accept": 'application/json'
          },
        }).
        then((responseText) => {
          let response = responseText.json();
          response.then((appraisalInfoJson) => {
            that.setState({
              appraisalJson: null,
            }, () => {
              that.setState({
                appraisalJson: appraisalInfoJson,
                isLoadingAppraisalInfo: false,
                editAppraisalJson: true,
              });
            });
          });
        });
    }
    else {
      alert('Appraisal JSON changes for Job id = '+
        this.state.selectedJobId+
        ' not saved.'
      );
    }
  }

  render() {
    let ImagesUploadCare = [];
    if (this.state.selectedTask === 'get_job_images_directory_listing' &&
      this.state.jobImagesDirectoryListingUploadCare !== null) {
      if (this.state.jobImagesDirectoryListingUploadCare.length > 0) {
        if(this.state.jobImagesDirectoryListingUploadCare[0].includes("https://"))
        {
          this.state.jobImagesDirectoryListingUploadCare.forEach(function (i) {
            ImagesUploadCare.push(
              <div
                className="col-md-6 system-support-directory-listing-image-container"
                key={i}
              >
                <p className="text-left">
                  <strong>
                    {i}
                  </strong>
                </p>
                <img
                  src={i}
                  className="system-support-directory-listing-image"
                />
              </div>
            );
          });
        }else {
          ImagesUploadCare.push(<h1>No images found</h1>);
        }
      }
      else {
        ImagesUploadCare.push(<h1>No images found</h1>);
      }
    }
    let Images = [];
    if (this.state.selectedTask === 'get_job_images_directory_listing' &&
      this.state.jobImagesDirectoryListing !== null) {
      if (this.state.jobImagesDirectoryListing.length > 0) {
        this.state.jobImagesDirectoryListing.forEach(function (i) {
          Images.push(
            <div
              className="col-md-6 system-support-directory-listing-image-container"
              key={i}
            >
              <p
                className="text-left"
              >
                <strong>
                  https://ivs.trax-app.net{i}
                </strong>
              </p>
              <p className="text-left">
                <strong>
                  {i}
                </strong>
              </p>
              <img
                src={i}
                className="system-support-directory-listing-image"
              />
            </div>
          );
        });
      }
      else {
        Images.push(<h1>No images found</h1>);
      }
    }
    const appraisalJsonCheck = (
      this.state.appraisalJson &&
      typeof this.state.appraisalJson === 'object' &&
      !Array.isArray(this.state.appraisalJson) &&
      Object.keys(this.state.appraisalJson).length > 0
    ) ? this.state.appraisalJson : [];
    return (
      <div className="portal-system-support-container">
        <div className="row text-center">
          <div className="col-md-12">
            <h1><img src="/images/g4-logo.jpg" />
              System Support Control Panel</h1>
          </div>
        </div>
        <div className="row text-center">
          <div className="col-md-12">
            <button
              className="btn btn-lg btn-primary"
              onClick={(e) => {
                this.fixAppraisalJson();
              }}
              title=" (i.e. white screen on [full details] bug)"
            >
              <i className="fa fa-life-ring"></i>&nbsp;
              Job Appraisal JSON
            </button>&nbsp;
            <button
              className="btn btn-lg btn-success"
              onClick={(e) => {
                this.getImagesDirectoryListing();
              }}
            >
              <i className="fa fa-life-ring"></i>&nbsp;
              Job Images
            </button>&nbsp;
            <button
              className="btn btn-lg btn-warning"
              onClick={(e) => {

              }}
              >
              <i className="fa fa-edit"></i>&nbsp;
              Advanced Full Job Edit
            </button>&nbsp;
            <button
              className="btn btn-lg btn-dark"
              onClick={(e) => {
                this.plateTrace();
              }}
            >
              <i className="fa fa-car"></i>&nbsp;
              Plate Trace
            </button>&nbsp;
            <button
              className="btn btn-lg btn-dark"
              onClick={(e) => {
                this.driverAppCurrentVersionReport();
              }}
            >
              <i className="fa fa-users-cog"></i>&nbsp;
              Driver App Current Version Report
            </button>

          </div>
        </div>
        <div className="row add-top-margin-spacer">
          <div className="col-md-12">
            <div className="alert alert-info">
              {(this.state.selectedJobId !== null) ?
                <div>
                  <p>
                    <strong>
                      You have selected Job with id = {
                      this.state.selectedJobId
                    }
                    </strong>
                  </p>
                  <p>
                    <a
                      target="_blank"
                      href={
                        "/jobs/view/" +
                        this.state.selectedJobId
                      }
                    >
                      https://ivs.trax-app.net/jobs/view/{
                      this.state.selectedJobId
                    }
                    </a>
                  </p>
                </div>
                : ''
              }
            </div>
          </div>
        </div>
        {(this.state.selectedTask === 'get_job_images_directory_listing') ?
          <div>
            <div className="row">
              <div className="col-md-4">
                <h1>Get Job Images Info.</h1>
                <p>
                  <strong>Find all images in system for a certain job.</strong>
                </p>
                <div className="row">
                  <div className="col-md-6">
                <input
                  className="form-control form-control-lg text-center"
                  value={this.state.selectedJobId}
                  onChange={(e) => {
                    this.setState({
                      selectedJobId: e.target.value
                    });
                  }}
                />
                  </div>
                <div className="col-md-6">
                <button
                  className="btn btn-lg btn-success"
                  onClick={(e) => {this.getImagesDirectoryListingInfo()}}
                ><i className="fa fa-file-image"></i> Get Images Now</button>
                </div>
                </div>
              </div>
              <div className="col-md-8">
                <p className="text-center">
                  <label className="system-support-radio-container">
                    <input
                      className="form-control form-control-lg"
                      onClick={(e) => {
                        this.setState({
                          uploadImageTypeValue: 'appraisal',
                          uploadImageTypeLabel: 'Appraisal'
                        })
                      }}
                      type="radio"
                      name="upload_image_type"
                      value="appraisal"
                    /> Appraisal
                  </label>
                  <label className="system-support-radio-container">
                    <input
                      onClick={(e) => {
                        this.setState({
                          uploadImageTypeValue: 'signature',
                          uploadImageTypeLabel: 'Customer Signature'
                        })
                      }}
                      className="form-control form-control-lg"
                      type="radio"
                      name="upload_image_type"
                      value="signature"
                    /> Signature
                  </label>
                </p>
                <p className="text-center">
                  <button
                    onClick={() => {
                      this.triggerUpload(this.state.selectedJobId)
                    }}
                    className="btn btn-lg btn-info"
                  >
                    <i className="fa fa-upload"></i>&nbsp;
                    Upload New {this.state.uploadImageTypeLabel
                  } Image to Job#{this.state.selectedJobId}
                  </button>

                  <input
                    type='file'
                    onChange={(e) => {this.uploadJobImage(e)}}
                    className="form-control image-input"
                    id="image-input"
                  />
                  <input
                    type="hidden"
                    name="image-base-64"
                    id="b64"
                  />
                </p>
              </div>
            {Images}
            {ImagesUploadCare}
            </div>
          </div>
          : ''
        }
        {(this.state.selectedTask === 'fix_appraisal') ?
          <div>
            <button
              className="btn btn-lg btn-dark"
              onClick={(e) => {
                this.editAppraisal();
              }}
            >
              <i className="fa fa-download"></i>&nbsp;
              Load Appraisal JSON data
            </button>&nbsp;
            <button
              className="btn btn-lg btn-outline-warning"
              onClick={(e) => {
                this.copyPickupToDropoff();
              }}
            >
              <i className="fa fa-clone"></i>&nbsp;
              Copy Pickup Appraisal to Dropoff Appraisal
            </button>&nbsp;
            <button
              className="btn btn-lg btn-outline-warning"
              onClick={(e) => {
                this.mergePickupAndDropoff()
              }}
            >
              <i className="fa fa-clone"></i>&nbsp; Merge Pickup Appraisal to
              Dropoff Appraisal
            </button>
            &nbsp;  
            {(this.state.editAppraisalJson === true) ?
              <>
              <button
                className="btn btn-lg btn-danger"
                onClick={(e) => {this.saveAppraisalJsonChanges(e)}}
              >
                <i className="fa fa-save"></i>&nbsp;
                Save Appraisal JSON changes to Job id = {
                this.state.selectedJobId
              }
              </button>&nbsp;
              </>
              : ''
            }
             {appraisalJsonCheck.length <= 0  ?
              <button
                className="btn btn-lg btn-primary"
                onClick={(e) => {this.addBlankAppraisalJSON(e)}}
              >
                <i className="fa fa-save"></i>&nbsp;
                Add Appraisal JSON to Job id = {
                this.state.selectedJobId
              }
              </button>
              : ''
            }
            {(this.state.editAppraisalJson === true &&
              this.state.isLoadingAppraisalInfo === false) ?
              <Editor
                value={this.state.appraisalJson}
                onChange={(option) => this.setState({
                  appraisalJson: option
                })}
              />
              : ''
            }
          </div>
          : ''
        }

        {(this.state.selectedTask === 'plate_trace') ?
          <div>
            <h1>Plate Trace</h1>
            <p>
              <strong>
                Find all vehicles in system by registration plate number
              </strong>
            </p>
            <div className="row">
              <div className="col-md-8">
                <input
                  className="form-control form-control-lg"
                  type="text"
                  value={this.state.plateToTrace}
                  onChange={(e) => {
                    this.setState({
                      plateToTrace: e.target.value
                    })
                  }}
                />
              </div>
              <div className="col-md-4">
                <button
                  className="btn btn-lg btn-dark"
                  onClick={(e) => {this.tracePlate()}}
                >
                  <i className="fa fa-search"></i> Trace Plate
                </button>
              </div>
            </div>
          </div>
          : ''
        }

        {(this.state.selectedTask === 'driver_app_current_version_report') ?
          <div className="text-center">
            <h1>Driver App Current Version Report</h1>
            <p>
              <strong>
                Based on the driver app reporting the version number to the API.
              </strong>
            </p>
            <div className="row">
              <div className="col-md-12">
                <label>
                <input
                  type="checkbox"
                  disabled={true}
                  value={this.state.includeLockedDriversInCurrentVersionReport}
                  onChange={(e) => {
                    this.setState({
                      includeLockedDriversInCurrentVersionReport: !this.
                        state.includeLockedDriversInCurrentVersionReport
                    });
                  }}
                /> Include Locked Drivers In Current Version Report?
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <button
                  className="btn btn-lg btn-dark"
                  onClick={(e) => {
                    this.generateDriverAppCurrentVersionReport()
                  }}
                >
                  <i className="fa fa-cogs"></i> Generate
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {(this.state.isLoadingDriverAppCurrentVersionReport)?
                <div
                  className="system-support-driver-app-current-version-report-spinner-container"
                >
                  <i className="fa fa-cog fa-spin fa-10x"></i>
                </div>
                :
                  <div
                    className="text-left
                    system-support-driver-app-current-version-report-container"
                    dangerouslySetInnerHTML={
                      this.getReport()
                    }
                  />
                }
              </div>
            </div>
          </div>
          : ''
        }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-portal-admin-system-support'
)) {
  ReactDOM.render(
    <SystemSupport />,
    document.getElementById(
      'react-component-g4-logistics-portal-portal-admin-system-support'
    )
  );
}